'use strict';

import {environment} from '@quartz-iam-legacy/environments/environment';

angular.module('directives.fallback', [])

.directive('fallbackSrc', function () {
  var fallbackSrc = {
        link: function postLink(scope, element, attrs) {
            var watcher = scope.$watch(function() {
                return attrs['ngSrc'];
            }, function (value) {
                if (!value) {
                    element.attr('src', attrs.fallbackSrc);
                }
            });

            element.bind('error', function() {
                if (element.attr('src')) {
                  // Fallback src is not set yet
                  if (element.attr('src') !== attrs.fallbackSrc) {
                    // Asset URL has been applied, but image was still not able to load. Use fallback
                    if (element.attr('data-with-asset-url')) {
                        element.attr('src', attrs.fallbackSrc);
                    // Apply asset URL to src
                    } else {
                        element.attr('src', `${environment.baseAssetUrl}/${attrs.src}`);
                        element.attr('data-with-asset-url', true);
                    }
                  }
                // There is no src path, apply fallback
                } else {
                  element.attr('src', attrs.fallbackSrc);
                }
            });

            // unsubscribe on success
            element.bind('load', watcher);
        }
  }
    return fallbackSrc;
});
